import Request from './request'

async function fetchOne(id, data) {
  // 获取单个
  return Request('get', 'api/orders/' + id, data)
}

export default {
  fetchOne,
}